export type AgentScheme = 'http' | 'https';

export interface AgentAddress {
  scheme: AgentScheme;
  host: string;
  // Texte, comme dans le champ : « 4310 », ou vide.
  port: string;
}

// Le port de l'agent d'impression quand rien n'est déclaré (celui du package @m-scan/device-kit-agent).
export const DEFAULT_AGENT_PORT = '4310';

const HOST =
  /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/i;

// L'adresse d'un agent déclarée ou saisie, découpée pour un formulaire : une adresse illisible redonne les valeurs par défaut.
export const parseAgentUrl = (value: string): AgentAddress => {
  try {
    const url = new URL(value.trim());
    return {
      scheme: url.protocol === 'https:' ? 'https' : 'http',
      host: url.hostname,
      port: url.port,
    };
  } catch {
    return { scheme: 'http', host: '', port: DEFAULT_AGENT_PORT };
  }
};

export const buildAgentUrl = ({ scheme, host, port }: AgentAddress) =>
  `${scheme}://${host.trim()}${port.trim() ? `:${port.trim()}` : ''}`;

// Ce qui manque ou cloche dans l'adresse, avant d'appeler l'agent.
export const agentAddressError = ({ host, port }: AgentAddress) => {
  if (!host.trim()) return 'Saisissez l’adresse IP de l’agent.';
  if (!HOST.test(host.trim()) || /^\d+$/.test(host.trim()))
    return 'Cette adresse n’est pas valide. Exemple : 192.168.1.10';
  const number = Number(port);
  if (
    port.trim() &&
    (!Number.isInteger(number) || number < 1 || number > 65535)
  )
    return 'Le port doit être un nombre entre 1 et 65535.';
  return null;
};
